import { render, staticRenderFns } from "./12.vue?vue&type=template&id=2fbb2694&scoped=true&"
import script from "./12.vue?vue&type=script&lang=js&"
export * from "./12.vue?vue&type=script&lang=js&"
import style0 from "./12.vue?vue&type=style&index=0&id=2fbb2694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb2694",
  null
  
)

export default component.exports